<template>
  <div class="intro mb">
    <p class="instructions">
      <span class="text">Scroll&nbsp;&nbsp;</span>
      <img aria-hidden="true" alt="down arrow" src="../assets/scroll_arrow.svg" />
      <span class="text">&nbsp;&nbsp;Down</span>
    </p>
    <slot name="title"></slot>
    <slot name="cta"></slot>
    <slot></slot>
    <slot name="p"></slot>
    <p class="body" v-for="(p, index) in copy">{{ p }}</p>
    <slot name="cta-bottom"></slot>
    <slot name="list"></slot>
    <slot name="twoColumns"></slot>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  props: [
    'copy'
  ],
  data () {
    return {
      // 'copy': copy
      // title: 'Header 1: Title',
      // imgSrc: 'http://via.placeholder.com/1900x1080'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/_vars';
  .intro {
    position: relative;
    display: block;
    padding-bottom: 55px;
    padding-top: 20px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -75px;
    background-color: #FFF;
    z-index: 1;
    border-radius: 5px;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
    margin-left: 15px;
    margin-right: 15px;
    padding-left: 25px;
    padding-right: 25px;
    @media(min-width: $screen-sm-min) {
      // margin-left: 25px;
      // margin-right: 25px;
      // padding-left: 35px;
      // padding-right: 35px;
      margin-left: 35px;
      margin-right: 35px;
      padding-left: 70px;
      padding-right: 70px;
    }
    @media(min-width: $screen-md-min) {
      margin-left: 35px;
      margin-right: 35px;
      padding-left: 70px;
      padding-right: 70px;
    }
    @media(min-width: $screen-lg-min) {
      margin-left: 55px;
      margin-right: 55px;
      padding-left: 105px;
      padding-right: 105px;
    }
  }
  .instructions {
    text-align: center;
    margin-bottom: 22px;
    .text {
      // opacity: .2;
      // color: #757575;
      color: #4c4c4c
    }
    > img {
      opacity: .3
    }
  }
  h2, h3, h4, h5 {
    margin-bottom: 16px;
  }
  img {
    width: 10px;
    transform: translateY(9px);
  }
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue